import React from 'react';
import PropTypes from 'prop-types';
import { AlertTriangle, User } from 'react-feather';
import { uniqueId } from 'lodash';
import classNames from 'classnames';
import { Card } from 'ui';
import { toList } from 'utils/string_utils';
import ToGradeSection from './ToGradeSection';

const awaitingGradeText = daysAwaitingGrade => {
  if (daysAwaitingGrade === 0) {
    return t('grades.awaiting_grade_time.today');
  }
  if (daysAwaitingGrade === 1) {
    return `${daysAwaitingGrade} ${t('grades.awaiting_grade_time.one_day')}`;
  }
  return `${daysAwaitingGrade} ${t('grades.awaiting_grade_time.days')}`;
};

const desiginatedGraderList = (designatedGraders, currentUser) => {
  const currentUserIndex = designatedGraders.indexOf(currentUser?.name);
  if (currentUserIndex !== -1) {
    designatedGraders[currentUserIndex] = t(
      'grades.designated_graders_with_current_grader',
    );
  }
  if (designatedGraders.length > 3) {
    return toList(
      [
        ...designatedGraders.slice(0, 3),
        t('grades.designated_graders_count_list', {
          remaining_graders: designatedGraders.length - 3,
        }),
      ],
      true,
    );
  }
  return toList(designatedGraders, true);
};

const GradingStationCard = ({
  progress,
  ziggeoApiKey,
  currentUser,
  stalenessThreshold,
  markProgressGraded,
}) => {
  const isStale = progress.daysAwaitingGrade > stalenessThreshold;
  return (
    <Card id={uniqueId('progress')} className="mb-32 ff-ss">
      <Card.Content padding="large">
        <div className="d-f w-fill jc-sb ai-c mb-8">
          <h2 className="c-gray-darkest fz-24 fw-b ff-ss">
            {progress.lessonName}
          </h2>
          <span
            className={classNames(
              'bdrs-small c-white d-f ai-c fw-b fz-sm p-4-8 d-f',
              {
                'bg-gray-dark': !isStale,
                'bg-red': isStale,
              },
            )}
            data-test-id="Grading-Station-staleness-card"
          >
            {isStale && <AlertTriangle size={16} className="mr-4" />}
            {awaitingGradeText(progress.daysAwaitingGrade)}
          </span>
        </div>
        <div className="d-f w-fill ai-c">
          <span className="c-gray-darkest fz-18 fw-b f-3 d-f ai-c">
            <User className="mr-8 mb-1 c-brand-gray" size={18} />
            {progress.userName}
          </span>
          {progress.designatedGraders && progress.designatedGraders.length > 0 && (
            <span className="c-gray-darkest f-1 d-f jc-e text-wrap ta-r">
              {`${t('grades.designated_grader', {
                count: progress.designatedGraders.length,
              })} ${desiginatedGraderList(
                progress.designatedGraders,
                currentUser?.name,
              )}`}
            </span>
          )}
        </div>
        <ToGradeSection
          progress={progress}
          currentUser={currentUser}
          ziggeoApiKey={ziggeoApiKey}
          markProgressGraded={markProgressGraded}
        />
      </Card.Content>
    </Card>
  );
};

GradingStationCard.propTypes = {
  currentUser: PropTypes.shape({
    name: PropTypes.string,
    id: PropTypes.number,
  }),
  stalenessThreshold: PropTypes.number,
  progress: PropTypes.shape({
    id: PropTypes.number,
    userName: PropTypes.string,
    lessonName: PropTypes.string,
    daysAwaitingGrade: PropTypes.number,
    designatedGraders: PropTypes.arrayOf(PropTypes.string),
  }),
  markProgressGraded: PropTypes.func,
  ziggeoApiKey: PropTypes.string,
};

export default GradingStationCard;
